import { BaseJsonSchema, createSchemaByBasicTypes } from "../../../helpers";

export const KargoBidSchema: BaseJsonSchema = {
  type: "object",
  properties: {
    bidder: {
      type: "string",
      enum: ["kargo"],
    },
    params: {
      type: "object",
      properties: {
        placementId: createSchemaByBasicTypes("string", null, {
          additionalProperties: false,
        }),
      },
      required: ["placementId"],
    },
  },
  additionalProperties: false,
  required: ["bidder", "params"],
};
